// extracted by mini-css-extract-plugin
export default {"title":"Exchange_title__t4hWC","pager":"Exchange_pager__zQIfu"};